import { render, staticRenderFns } from "./SafeControlList.vue?vue&type=template&id=242092a8&scoped=true"
import script from "./SafeControlList.vue?vue&type=script&lang=js"
export * from "./SafeControlList.vue?vue&type=script&lang=js"
import style0 from "./SafeControlList.vue?vue&type=style&index=0&id=242092a8&prod&lang=scss"
import style1 from "./SafeControlList.vue?vue&type=style&index=1&id=242092a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242092a8",
  null
  
)

export default component.exports